module.exports = __webpack_public_path__ + "img/yellow-badge.d7b87bc6.png";